export default {
  noAlarms: 'No active alarms found',
  activeAlarms: 'Active alarms',
  acknowledgeAll: 'Acknowledge all',
  enableNotificationsForNewAlarms: 'Notify on alarms',
  enableNotificationsForNewAlarmsTooltip: 'Show a browser notification when a new alarm appears.',
  newAlarmNotificationTitle: 'New alarm',
  notificationsPermissionDeniedTooltip: 'You did not allow notifications in your browser.',
  notificationsPermissionUnsupportedTooltip: 'Your browser does not support notifications.',
};
